package com.nonopn.skydome.common.app.detection

import com.nonopn.skydome.common.app.pages.probes.ProbeStatusInput
import com.nonopn.skywatcher.maps.LatLng
import kotlinx.serialization.Serializable

@Serializable
data class ThunderDetection(
    val uuid: String,
    val name: String,
    val latitude: Double,
    val longitude: Double,
    val createdAtSecondsUtc: Long = 0L,
    // Billing status of the probe (all optional: older servers do not send them)
    // status = trial | unpaid | active | expired
    val status: String? = null,
    val isDemo: Boolean = false,
    val enabled: Boolean? = null,
    val validUntilSecondsUtc: Long? = null,
    val trialEndsAtSecondsUtc: Long? = null,
) {
    fun statusInput() = ProbeStatusInput(
        status = status,
        isDemo = isDemo,
        enabled = enabled,
        validUntilSecondsUtc = validUntilSecondsUtc,
        trialEndsAtSecondsUtc = trialEndsAtSecondsUtc,
    )

    fun position() = LatLng(
        latitude = latitude,
        longitude = longitude
    )

    companion object {
        val fakes = listOf(
            ThunderDetection(
                uuid = "fake1",
                name = "Golf Bluegreen Bordeaux Lac (Storm)",
                latitude = 44.9058125,
                longitude = -0.5707903,
            )
        )
    }
}
